import script from "./NoticeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeItem.vue?vue&type=script&setup=true&lang=js"

import "./NoticeItem.vue?vue&type=style&index=0&id=7656fb62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7656fb62"]])

export default __exports__